module.exports = __webpack_public_path__ + "assets/images/pages/eu-funds/profesionais.png?e84ac1f8";